import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  saveOrUpdateSettings,
  getSettings,
} from "../../../services/RHService/PaiementSettingsService";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";

const PaiementSettings = () => {
  const [formData, setFormData] = useState({
    cnss: 0,
    css: 0,
    mChefDefamille: 0,
    mEnfant: 0,
    mEnfantNonBoursier: 0,
    mParent: 0,
    deusiemeTauxIr: 0,
    troisiemeTauxIr: 0,
    quateriemTauxIr: 0,
  });
  const [setting, setSetting] = useState([]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const response = await saveOrUpdateSettings(getCurrentUserId(), formData);
      if (response) {
        setSetting(response.success);
        toastr.success("Les données ont été enregistrées.");
      } else if (response && response.status === "error") {
        toastr.error(response.message);
      }
    } catch (error) {
      toastr.error("Erreur lors  l'insertion.");
    }
  };
  useEffect(() => {
    getSettings(getCurrentUserId())
      .then((data) => {
        setSetting(data.success);
        setFormData(data.success); // Set initial form values
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Paramètres de paie </h1>
              <hr></hr>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Paramètres de paie</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card card-dark">
                  <div class="card-header">
                    <h4 class="card-title">
                      Caisse Nationale de Sécurité Sociale
                    </h4>
                  </div>
                  <div className="row mt-4 mx-2">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label htmlFor="exampleInputPassword1">
                          Taux de cotisation de CNSS
                        </label>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control form-control-bordered"
                          value={formData ? formData.cnss : 0}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              cnss: e.target.value,
                            })
                          }
                          name="cnss"
                          placeholder=""
                          id="exampleInputPassword1"
                        />
                      </div>
                    </div>
                    <div className="col-md-1">%</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-dark">
                  <div className="card-header">
                    <h4 className="card-title">
                      Cotisations Sociales Salariées
                    </h4>
                  </div>
                  <div className="row mt-4 mx-2">
                    <div className="col-md-3 ">
                      <div className="form-group">
                        <label htmlFor="exampleInputPassword1">
                          Taux de CSS
                        </label>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control form-control-bordered"
                          value={formData ? formData.css : 0}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              css: e.target.value,
                            })
                          }
                          name="css"
                          placeholder=""
                          id="exampleInputPassword1"
                        />
                      </div>
                    </div>
                    <div className="col-md-1 ">%</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-dark">
                  <div className="card-header">
                    <h4 className="card-title">Situation Familiale</h4>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card-body">
                        <div className="row ">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label htmlFor="exampleInputPassword1">
                                Montant chef de famille{" "}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control form-control-bordered"
                                value={formData ? formData.mChefDefamille : 0}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    mChefDefamille: e.target.value,
                                  })
                                }
                                name="mChefDefamille"
                                placeholder=""
                              />
                            </div>
                          </div>
                          <div className="col-md-1 ">DT</div>
                        </div>

                        <div className="row ">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label htmlFor="exampleInputPassword1">
                                Montant enfant à charge (&lt;20 ans){" "}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control form-control-bordered"
                                value={formData ? formData.mEnfant : 0}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    mEnfant: e.target.value,
                                  })
                                }
                                name="mEnfant"
                                placeholder=""
                                id="exampleInputPassword1"
                              />
                            </div>
                          </div>
                          <div className="col-md-1 ">DT</div>
                        </div>

                        <div className="row ">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label htmlFor="exampleInputPassword1">
                                Montant enfant non boursier{" "}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control form-control-bordered"
                                value={
                                  formData ? formData.mEnfantNonBoursier : 0
                                }
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    mEnfantNonBoursier: e.target.value,
                                  })
                                }
                                name="mEnfantNonBoursier"
                                placeholder=""
                                id="exampleInputPassword1"
                              />
                            </div>
                          </div>
                          <div className="col-md-1 ">DT</div>
                        </div>
                        <div className="row ">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label htmlFor="exampleInputPassword1">
                                Montant parent à charge{" "}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control form-control-bordered"
                                value={formData ? formData.mParent : 0}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    mParent: e.target.value,
                                  })
                                }
                                name="mParent"
                                placeholder=""
                                id="exampleInputPassword1"
                              />
                            </div>
                          </div>
                          <div className="col-md-1 ">DT</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-dark">
                  <div className="card-header">
                    <h4 className="card-title">Les impôts sur le revenu </h4>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card-body">
                        <div className="row ">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label htmlFor="exampleInputPassword1">
                                1er Taux d'impôt sur le revenu (entre 0 et
                                5.000Dt){" "}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control form-control-bordered"
                                value={formData ? formData.premiereTauxIr : 0}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    premiereTauxIr: e.target.value,
                                  })
                                }
                                name="premiereTauxIr"
                                placeholder=""
                                id="exampleInputPassword1"
                              />
                            </div>
                          </div>
                          <div className="col-md-1 ">%</div>
                        </div>
                        <div className="row ">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label htmlFor="exampleInputPassword1">
                                2ème Taux d'impôt sur le revenu (entre 5001 et
                                20.000Dt){" "}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control form-control-bordered"
                                value={formData ? formData.deusiemeTauxIr : 0}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    deusiemeTauxIr: e.target.value,
                                  })
                                }
                                name="deusiemeTauxIr"
                                placeholder=""
                                id="exampleInputPassword1"
                              />
                            </div>
                          </div>
                          <div className="col-md-1 ">%</div>
                        </div>
                        <div className="row ">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label htmlFor="exampleInputPassword1">
                                3ème Taux d'impôt sur le revenu (entre 20.001 et
                                30.000Dt){" "}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control form-control-bordered"
                                value={formData ? formData.troisiemeTauxIr : 0}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    troisiemeTauxIr: e.target.value,
                                  })
                                }
                                name="troisiemeTauxIr"
                                placeholder=""
                                id="exampleInputPassword1"
                              />
                            </div>
                          </div>
                          <div className="col-md-1 ">%</div>
                        </div>
                        <div className="row ">
                          <div className="col-md-3">
                            <div className="form-group">
                              <label htmlFor="exampleInputPassword1">
                                4ème Taux d'impôt sur le revenu (&gt;30.001 Dt){" "}
                              </label>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control form-control-bordered"
                                value={formData ? formData.quateriemTauxIr : 0}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    quateriemTauxIr: e.target.value,
                                  })
                                }
                                name="quateriemTauxIr"
                                placeholder=""
                                id="exampleInputPassword1"
                              />
                            </div>
                          </div>
                          <div className="col-md-1 ">%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer">
            <button
              type="submit"
              className="btn btn-dark col-md-3 float-right"
              style={{ width: "auto" }}
            >
              Enregistrer
            </button>
          </div>
        </section>
      </form>
    </div>
  );
};
export default PaiementSettings;
